import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import BackBtn from 'components/buttons/BackBtn'
import Select from 'components/inputs/Select'
import { displayPrice } from 'utils/string'
import Loading from 'components/Loading'
import Error from 'components/Error'
import { SelectedPeriods } from '.'
import React from 'react'

const type = process.env.REACT_APP_TYPE

interface PayExtraFormProps {
  isPopup?: boolean
  isLoading: boolean
  data: payments.CancelRentalResponse | null
  selectedPeriods: SelectedPeriods
  selectPeriods: React.Dispatch<React.SetStateAction<SelectedPeriods>>
  finalize: (amount: number) => void
}

const PayExtraForm: React.FC<PayExtraFormProps> = ({ isPopup, isLoading, data, selectedPeriods, selectPeriods, finalize }) => {
  let finalAmount = 0
  const showSummary = Object.keys(selectedPeriods).length > 0

  const { t } = useTranslation('payment')
  const calculateAmount = (period: number, schedule: payments.WarehouseRentalScheduleTile[]) => {
    let amount = 0
    for (let i = 0; i <= period; i++) {
      amount += Number(schedule[i].grossPrice || 0)
    }
    return amount
  }

  return (
    <>
      <div className='payExtra__main'>
        <div className={isPopup ? 'popup__title' : 'title'}>
          <div>{t('payInAdvanceTitle')}</div>
          <div>{t('untilWhenDoYouWantToPayRental')}</div>
        </div>

        {data
          ? <div className='payExtra__items'>
            {data.warehouses.map((warehouse) => {
              const schedule = warehouse.schedule?.[0]
              const selectedPeriod = selectedPeriods[warehouse.id] ?? -1
              return <div
                key={warehouse.id}
                className='payExtra__item'>
                <p>{t(`warehouse.${type}`)} {warehouse.number} | {warehouse.placeAddress}</p>
                {schedule
                  ? <Select
                    label=''
                    value={selectedPeriod}
                    secondaryTheme={isPopup}
                    setValue={value => {
                      selectPeriods(prev => {
                        if (value === -1) {
                          const { [warehouse.id]: _, ...rest } = prev
                          return rest
                        } else {
                          return { ...prev, [warehouse.id]: value }
                        }
                      })
                    }}
                    options={[
                      { name: t('select'), value: -1 },
                      ...schedule.tiles.map((s, idx) => ({
                        name: `${s.title} (${idx + 1} ${t(!idx ? 'month' : idx < 4 ? 'month<5' : 'month>=5')})`,
                        value: idx
                      }))
                    ]}
                  />
                  : <Select
                    value=''
                    label=''
                    disabled
                    setValue={() => { }}
                    options={[
                      { name: t('entireRentalPeriodIsPaid'), value: '' },
                    ]}
                  />}
              </div>
            })}

          </div>
          : isLoading
            ? <Loading middleOfPage={!isPopup} />
            : <Error />}

        {showSummary && data && <>
          <p>{t('summary')}</p>
          <div className='payExtra__summary'>
            <div className='payExtra__summary__items'>
              {data.warehouses.map((warehouse) => {
                const schedule = warehouse.schedule?.[0]
                const selectedPeriod = selectedPeriods[warehouse.id] ?? -1
                if (selectedPeriod < 0 || !schedule) return null
                const amount = calculateAmount(selectedPeriod, schedule.tiles)
                finalAmount += amount
                return <div
                  key={warehouse.id}
                  className='payExtra__summary__item'>
                  <span>{selectedPeriod + 1} x {t('monthlyFeeForStorageUnit')} {warehouse.number}</span>
                  <span>{displayPrice(amount)}</span>
                </div>
              })}
            </div>
            <div className='payExtra__summary__total'>
              <span>{t('total')}</span>
              <span>{displayPrice(finalAmount)}</span>
            </div>
          </div>
        </>}
      </div>

      <div className='payExtra__buttons'>
        <ArrowBtn
          enlarged
          disabled={!finalAmount}
          text={`${t('pay')} ${displayPrice(finalAmount)}`}
          action={() => {
            finalize(finalAmount)
          }}
        />
        <BackBtn />
      </div>
    </>
  )
}

export default PayExtraForm